import React from "react";

const Java_Super = () => {
  return (
    <div>
      <h1>Java Super</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Super in Java.</p>
    </div>
  );
};

export default Java_Super;
